type MockBiometricUserLimitation = {
  code: string;
  message: string;
};

type MockBiometricUser = {
  id: string;
  userType: "Employee" | "Contractor";
  name: string;
  pictureUrl: string | null;
  pictureLastModified: string | null;
  role: string;
  roleType: string;
  locationCode: string | null;
  kronosId: string | null;
  recordStartDate: string | null;
  recordEndDate: string | null;
  kronosHireDate: string | null;
  kronosStartDate: string | null;
  kronosTermDate: string | null;
  limitations?: MockBiometricUserLimitation[];
};

/** Raw API response — date fields are ISO strings before the Axios handleDates interceptor. */
export const mockBiometricUsers: {
  totalUserCount: number;
  users: MockBiometricUser[];
} = {
  totalUserCount: 8,
  users: [
    {
      id: "T0052245",
      userType: "Employee",
      name: "Ang Ussse",
      pictureUrl: null,
      pictureLastModified: null,
      role: "Dockworker",
      roleType: "Dock Worker",
      locationCode: "HOM",
      kronosId: null,
      recordStartDate: "2024-07-15T00:08:00",
      recordEndDate: null,
      kronosHireDate: null,
      kronosStartDate: null,
      kronosTermDate: null,
      limitations: [
        {
          code: "location_code_unmapped",
          message:
            'Location code "HOM" is not mapped to a service center, so Face ID cannot be set up.',
        },
      ],
    },
    {
      id: "H00001",
      userType: "Employee",
      name: "Test User",
      pictureUrl: null,
      pictureLastModified: null,
      role: "Service Center Management",
      roleType: "Service Center Management",
      locationCode: "LAX",
      kronosId: "1234",
      recordStartDate: "2024-07-09T00:08:30",
      recordEndDate: null,
      kronosHireDate: "2024-07-09T00:08:30",
      kronosStartDate: "2024-07-09T00:08:30",
      kronosTermDate: null,
    },
    {
      id: "H00002",
      userType: "Employee",
      name: "John Doe",
      pictureUrl: null,
      pictureLastModified: null,
      role: "Company Driver",
      roleType: "Company Driver",
      locationCode: "LAX",
      kronosId: null,
      recordStartDate: "2024-07-15T00:08:00",
      recordEndDate: null,
      kronosHireDate: null,
      kronosStartDate: null,
      kronosTermDate: null,
    },
    {
      id: "H00003",
      userType: "Employee",
      name: "Bee Hive",
      pictureUrl: null,
      pictureLastModified: null,
      role: "Dockworker",
      roleType: "Dock Worker",
      locationCode: "EWR",
      kronosId: null,
      recordStartDate: "2024-07-15T00:08:00",
      recordEndDate: null,
      kronosHireDate: null,
      kronosStartDate: null,
      kronosTermDate: null,
    },
    {
      id: "H00004",
      userType: "Employee",
      name: "Aaron Smith",
      pictureUrl: null,
      pictureLastModified: null,
      role: "Customer Service Reps",
      roleType: "CSR",
      locationCode: "EWR",
      kronosId: null,
      recordStartDate: "2024-07-15T00:08:00",
      recordEndDate: null,
      kronosHireDate: null,
      kronosStartDate: null,
      kronosTermDate: null,
    },
    {
      id: "H00005",
      userType: "Employee",
      name: "Without Picture",
      pictureUrl: null,
      pictureLastModified: null,
      role: "Service Center Management",
      roleType: "Service Center Management",
      locationCode: "LAX",
      kronosId: "1234",
      recordStartDate: "2024-07-09T00:08:30",
      recordEndDate: null,
      kronosHireDate: "2024-07-09T00:08:30",
      kronosStartDate: "2024-07-09T00:08:30",
      kronosTermDate: null,
    },
    {
      id: "IC9001",
      userType: "Contractor",
      name: "Alex Contractor",
      pictureUrl: null,
      pictureLastModified: null,
      role: "Independent Contractors",
      roleType: "Independent Contractor",
      locationCode: "111",
      kronosId: null,
      recordStartDate: null,
      recordEndDate: null,
      kronosHireDate: null,
      kronosStartDate: null,
      kronosTermDate: null,
    },
    {
      id: "IC9002",
      userType: "Contractor",
      name: "Brenda Contractor",
      pictureUrl: null,
      pictureLastModified: null,
      role: "Independent Contractors",
      roleType: "Independent Contractor",
      locationCode: "111",
      kronosId: null,
      recordStartDate: null,
      recordEndDate: null,
      kronosHireDate: null,
      kronosStartDate: null,
      kronosTermDate: null,
    },
  ],
};
